// Hier exporteren we alle schermen zodat we niet steeds moeilijk hoeven te doen met paden
export { HomeScreen } from './HomeScreen';
export { SearchScreen } from './SearchScreen';
export { FavoritesScreen } from './FavoritesScreen';
export { ScannerScreen } from './ScannerScreen';
export { ProductDetailScreen } from './ProductDetailScreen';
export { AlternativesScreen } from './AlternativesScreen';
export { default as FirstRunLanguageScreen } from './FirstRunLanguageScreen';
export { default as MinigameScreen } from './MinigameScreen';
